export function validLength(value, maxLength) {
  return value.length > maxLength ? true : false;
}

export default validLength;
